import util from '../util';

export const WEBSITE = 'WEBSITE';
export const WEBSITES = 'WEBSITES';
export const WEBSITES_LIGHT = 'WEBSITES_LIGHT';
export const WEBSITE_CREATE = 'WEBSITE_CREATE';
export const WEBSITE_UPDATE = 'WEBSITE_UPDATE';
export const WEBSITE_SET_THEME = 'WEBSITE_SET_THEME';
export const WEBSITE_UPDATE_TMP = 'WEBSITE_UPDATE_TMP';
export const RESET_WEBSITE = 'RESET_WEBSITE';
export const DELETE_WEBSITE = 'DELETE_WEBSITE';
export const AVAILABLE_THEMES = 'AVAILABLE_THEMES';
export const AVAILABLE_FONTS = 'AVAILABLE_FONTS';

export const WEBSITES_REQUEST = util.requestType(WEBSITES);
export const WEBSITES_SUCCESS = util.successType(WEBSITES);
export const WEBSITES_FAILURE = util.failureType(WEBSITES);

export const WEBSITES_LIGHT_SUCCESS = util.successType(WEBSITES_LIGHT);
export const WEBSITES_LIGHT_REQUEST = util.requestType(WEBSITES_LIGHT);
export const WEBSITES_LIGHT_FAILURE = util.failureType(WEBSITES_LIGHT);

export const WEBSITE_REQUEST = util.requestType(WEBSITE);
export const WEBSITE_SUCCESS = util.successType(WEBSITE);
export const WEBSITE_FAILURE = util.failureType(WEBSITE);

export const AVAILABLE_THEMES_REQUEST = util.requestType(AVAILABLE_THEMES);
export const AVAILABLE_THEMES_SUCCESS = util.successType(AVAILABLE_THEMES);
export const AVAILABLE_THEMES_FAILURE = util.failureType(AVAILABLE_THEMES);

export const AVAILABLE_FONTS_REQUEST = util.requestType(AVAILABLE_FONTS);
export const AVAILABLE_FONTS_SUCCESS = util.successType(AVAILABLE_FONTS);
export const AVAILABLE_FONTS_FAILURE = util.failureType(AVAILABLE_FONTS);

export const CREATE_WEBSITE_REQUEST = util.requestType(WEBSITE_CREATE);
export const CREATE_WEBSITE_SUCCESS = util.successType(WEBSITE_CREATE);
export const CREATE_WEBSITE_FAILURE = util.failureType(WEBSITE_CREATE);

export const UPDATE_WEBSITE_REQUEST = util.requestType(WEBSITE_UPDATE);
export const UPDATE_WEBSITE_SUCCESS = util.successType(WEBSITE_UPDATE);
export const UPDATE_WEBSITE_FAILURE = util.failureType(WEBSITE_UPDATE);

export const SET_WEBSITE_THEME_REQUEST = util.requestType(WEBSITE_SET_THEME);
export const SET_WEBSITE_THEME_SUCCESS = util.successType(WEBSITE_SET_THEME);
export const SET_WEBSITE_THEME_FAILURE = util.failureType(WEBSITE_SET_THEME);

export const WEBSITE_UPDATE_TMP_REQUEST = util.requestType(WEBSITE_UPDATE_TMP);
export const WEBSITE_UPDATE_TMP_SUCCESS = util.successType(WEBSITE_UPDATE_TMP);
export const WEBSITE_UPDATE_TMP_FAILURE = util.failureType(WEBSITE_UPDATE_TMP);

export const DELETE_WEBSITE_REQUEST = util.requestType(DELETE_WEBSITE);
export const DELETE_WEBSITE_SUCCESS = util.successType(DELETE_WEBSITE);
export const DELETE_WEBSITE_FAILURE = util.failureType(DELETE_WEBSITE);
